(function () {
    'use strict';

    angular
        .module('cog.shared.customer')
        .controller('ApiFiguresController', ApiFiguresController);

    /* @ngInject */
    function ApiFiguresController(notificationService: INotificationService, $filter, $state, $stateParams, CogApiServiceProvider: ICogApiServiceProvider, $window, moment, appSettings) {
        var vm = this;
        vm.apiError = false;
        vm.ShortDate = ShortDate;
        vm.WeekDay = WeekDay;
        vm.Weeks = [];
        vm.getPrevious = getPrevious;
        vm.getNumberClass = getNumberClass;
        vm.Detail = Detail;
        vm.selectedWeekId = ($stateParams.weekId && !isNaN($stateParams.weekId) && $stateParams.weekId > 1) ? $stateParams.weekId : 1; // 1 = prev week;
        vm.MaxHistory = 20;
        vm.curDateStr = "";
        vm.showDayCurWeek = showDayCurWeek;

        vm.weekHistoryLoader = true;
        vm.prevHistoryLoader = true;
	vm.figureSelectWeekTmpl = appSettings.sharedPath + 'customer/figures/select-week.tmpl.html'; // used in bm-figures.tmpl.html

        activate();

        function activate() {
            vm.weekHistoryLoader = true;
            vm.curDateStr = moment().format('YYYY-MM-DD');
            CogApiServiceProvider.apiAccService().getHistoryWeek(0)
                .success(function (response, status) {
                    if (status == 200) {
                        if (parseInt(response.ViewHistory) < 20 && parseInt(response.ViewHistory) != 0)
                            vm.MaxHistory = parseInt(response.ViewHistory);

                        //if (CogApiServiceProvider.is_BM()) {
                        // reverse Data on BM
                        vm.CurrentData = reverseWeekData(response);
                        /*} else {
                            vm.CurrentData = response;
                        }*/
                        getPreviousWeeks($filter('date')(vm.CurrentData.DateFrom));
                        //vm.prevWeek = vm.Weeks[0].Id;
                    }
                    else
                        vm.apiError = true;
                })
                .error(function (error) {
                    vm.apiError = true;
                }).finally(function () {
                    vm.weekHistoryLoader = false;
                });

            vm.prevHistoryLoader = true;
            CogApiServiceProvider.apiAccService().getHistoryWeek(vm.selectedWeekId)
                .success(function (response) {
                    vm.prevWeek = vm.selectedWeekId;
                    //if (CogApiServiceProvider.is_BM()) {
                        // reverse Data on BM
                        vm.OldData = reverseWeekData(response);
                    /*} else {
                        vm.OldData = response;
                    }*/
                })
                .error(function (error) {
                }).finally(function () {
                    vm.prevHistoryLoader = false;
                });
        }

        function reverseWeekData(response) {
            var new_response = $window._.clone(response);
            new_response.days = $window._.reverse(response.days);
            return new_response;
        }

        function ShortDate(input) {
            return $filter('date')(input, 'MMM dd');
        }

        function WeekDay(input) {
            var curDate = moment().format('YYYY-MM-DD');
            var inDate = new Date(input);
            if (curDate === input)
                return "Today";
            else
                return $filter('date')(input, 'EEEE');
        }

        function getPreviousWeeks(input) {
            var startDate: Date = new Date(input);
            startDate.setDate(startDate.getDate() + -7);
            for (var i = 1; i <= vm.MaxHistory; i++) {
                var endDate = new Date(String(startDate));
                endDate.setDate(startDate.getDate() + 6);
                var Week = {
                    Id: i,
                    Description: (i == 1) ? "Last Week" : $filter('date')(startDate, 'MMM dd') + " - " + $filter('date')(endDate, 'MMM dd')
                }
                startDate.setDate(startDate.getDate() + -7);
                vm.Weeks.push(Week);
            }
        }

        function getPrevious(week) {
            vm.selectedWeekId = week;
            vm.prevHistoryLoader = true;
            CogApiServiceProvider.apiAccService().getHistoryWeek(week)
                .success(function (response) {
                    //vm.OldData = response;
                    //if (CogApiServiceProvider.is_BM()) {
                        // reverse Data on BM
                        vm.OldData = reverseWeekData(response);
                   /* } else {
                        vm.OldData = response;
                    }*/
                })
                .error(function (error) {
                }).finally(function () {
                    vm.prevHistoryLoader = false;
                });
        }

        function getNumberClass(number) {
            if (parseInt(number)) {
                var num = parseInt(number);
                if (number > 0)
                    return "figGreen";
                else
                    return "figRed";
            }
            return "";
        }

        function Detail(day) {
            var stateStr = 'cog.default.customer-history';
            if (CogApiServiceProvider.is_BM())
                stateStr = 'bm.default.history';
            $state.go(stateStr, { historyDay: day, weekId: vm.selectedWeekId }, { location: true, inherit: true, relative: $state.$current, notify: true });
        }

        function showDayCurWeek(input) {
            var curDate = moment().format('YYYY-MM-DD');

            if (curDate < input)
                return false;
            else
                return true;
        }
    }
})();
